if (!window.__premiumKitScriptLoaded) {
  window.__premiumKitScriptLoaded = true;

  window.__freeGiftsKachingQty = null;
  window.__freeGiftsKachingTierIndex = null;
  window.__kachingDealBarOrder = [];

  // Visual unlock only — do not inject free gifts into ATC / cart yet.
  window.__freeGiftsCartEnabled = false;

  // Known Kaching deal-bar IDs → Buy 1 / Buy 2 / Buy 3
  const KACHING_DEAL_TIER_BY_ID = {
    "f716efec-1d18-4ba9-86f5-d5954f1797db": 1, // Buy 1 → all greyscale
    "d57150ec-e188-430a-bcc5-983be504198e": 2, // Buy 2 → first gift color
    Ey1A: 3, // Buy 3 → all gifts color
  };

  function buildHiddenInput(name, value, className) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    if (className) input.className = className;
    return input;
  }

  function getKachingWidget() {
    return document.querySelector("kaching-bundles-block");
  }

  function getQuantityFromKachingWidget(widget) {
    if (!widget) return null;

    try {
      if (typeof widget.items === "function") {
        const items = widget.items() || [];
        const qty = items.reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
        if (qty > 0) return qty;
      }
    } catch (_err) {}

    if (window.__freeGiftsKachingQty && window.__freeGiftsKachingQty > 0) {
      return window.__freeGiftsKachingQty;
    }

    // Theme quantity input (Kaching usually syncs this)
    const qtyInput =
      document.querySelector('form[action*="cart/add"].product-buy-form-pdp input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');
    if (qtyInput && qtyInput.value) {
      const n = parseInt(qtyInput.value, 10);
      if (n > 0) return n;
    }

    return null;
  }

  function resolveDealBarIndex(widget, dealBarId) {
    if (!dealBarId) return null;

    const id = String(dealBarId);
    if (Object.prototype.hasOwnProperty.call(KACHING_DEAL_TIER_BY_ID, id)) {
      return KACHING_DEAL_TIER_BY_ID[id];
    }

    // Allow short / partial IDs (e.g. Buy 3 "Ey1A")
    const lower = id.toLowerCase();
    for (const [knownId, tier] of Object.entries(KACHING_DEAL_TIER_BY_ID)) {
      const known = String(knownId).toLowerCase();
      if (lower === known || lower.startsWith(known) || known.startsWith(lower)) {
        return tier;
      }
    }

    if (!window.__kachingDealBarOrder.includes(id)) {
      window.__kachingDealBarOrder.push(id);
    }
    const tracked = window.__kachingDealBarOrder.indexOf(id);
    if (tracked >= 0) return tracked + 1;

    const roots = [widget, widget && widget.shadowRoot].filter(Boolean);
    for (const root of roots) {
      const nodes = Array.from(
        root.querySelectorAll(
          "[data-deal-bar-id], [data-deal-id], [data-dealbar-id], [data-id]"
        )
      );
      const matchIndex = nodes.findIndex((node) => {
        const nodeId =
          node.getAttribute("data-deal-bar-id") ||
          node.getAttribute("data-deal-id") ||
          node.getAttribute("data-dealbar-id") ||
          node.getAttribute("data-id");
        return nodeId && String(nodeId) === id;
      });
      if (matchIndex >= 0) return matchIndex + 1;
    }

    return null;
  }

  function getSelectedBundleTierIndex() {
    // Native Bundle Variant Picker (Buy 1 / Buy 2 / Buy 3 Shopify variants)
    if (window.__freeGiftsBundleVariantIndex) {
      return window.__freeGiftsBundleVariantIndex;
    }
    const bundleRadio = document.querySelector(
      "[data-bundle-variant-picker] .bundle-variant-picker__radio:checked"
    );
    if (bundleRadio) {
      const idx = parseInt(bundleRadio.getAttribute("data-option-index") || "0", 10);
      if (idx > 0) return idx;
    }

    // Kaching (legacy / other pages)
    if (window.__freeGiftsKachingTierIndex) {
      return window.__freeGiftsKachingTierIndex;
    }

    const widget = getKachingWidget();
    const qty = getQuantityFromKachingWidget(widget);
    if (qty != null) {
      return Math.min(Math.max(qty, 1), 4);
    }

    // Quantity Break fallback
    const selectedInput =
      document.querySelector(".quantity-break-option.selected input.quantity-break-input") ||
      document.querySelector("input.quantity-break-input:checked");
    if (selectedInput) {
      const idMatch = selectedInput.id && selectedInput.id.match(/quantity-break-option(\d+)/i);
      if (idMatch) return parseInt(idMatch[1], 10);
      return 1;
    }

    return null;
  }

  function getAllowedGiftCount(kitWrapper) {
    const tierIndex = getSelectedBundleTierIndex();
    if (tierIndex == null) return Number.POSITIVE_INFINITY;

    const attr = kitWrapper.getAttribute("data-gifts-option-" + tierIndex);
    if (attr == null || attr === "") return 0;

    const count = parseInt(attr, 10);
    return Number.isFinite(count) ? Math.max(0, count) : 0;
  }

  function updateGiftVisibility(kitWrapper) {
    const allowed = getAllowedGiftCount(kitWrapper);
    const items = Array.from(kitWrapper.querySelectorAll(".kit-item"));
    let activeCount = 0;

    // Always keep the Free Gifts block visible; locked cards use black overlay
    kitWrapper.hidden = false;
    kitWrapper.classList.remove("is-hidden-by-qb");
    kitWrapper.classList.toggle("has-locked-gifts", allowed < items.length);
    kitWrapper.classList.toggle("has-no-active-gifts", allowed <= 0);

    items.forEach((item) => {
      const giftIndex = parseInt(item.getAttribute("data-gift-index") || "0", 10);
      const unlocked = giftIndex > 0 && giftIndex <= allowed;
      item.hidden = false;
      item.classList.toggle("is-locked", !unlocked);
      item.setAttribute("data-gift-active", unlocked ? "true" : "false");
      item.setAttribute("aria-disabled", unlocked ? "false" : "true");
      if (unlocked) activeCount++;
    });

    return activeCount;
  }

  function getActiveGiftVariantIds(kitWrapper) {
    const ids = [];
    const seen = new Set();
    kitWrapper.querySelectorAll('.kit-item[data-gift-active="true"]').forEach((item) => {
      const id = item.getAttribute("data-product-id");
      const available = item.getAttribute("data-available") !== "false";
      if (id && available && !seen.has(id)) {
        seen.add(id);
        ids.push(id);
      }
    });
    return ids;
  }

  function collectActiveGifts() {
    const kitWrappers = Array.from(
      document.querySelectorAll(".premium-attachment-kit[data-qb-linked]")
    );
    const allGiftIds = [];
    let relyOnProductId = "";

    kitWrappers.forEach((kitWrapper) => {
      updateGiftVisibility(kitWrapper);
      if (kitWrapper.hidden) return;
      if (!relyOnProductId) {
        relyOnProductId =
          kitWrapper.getAttribute("data-rely-on-product-id") ||
          kitWrapper.getAttribute("data-main-product-id") ||
          "";
      }
      getActiveGiftVariantIds(kitWrapper).forEach((id) => {
        if (!allGiftIds.includes(id)) allGiftIds.push(id);
      });
    });

    return { allGiftIds, relyOnProductId, kitWrappers };
  }

  function syncPremiumKitIntoForm() {
    try {
      const { allGiftIds, relyOnProductId } = collectActiveGifts();

      if (typeof Elixir_ProductFormExists !== "function" || !Elixir_ProductFormExists()) return;
      const productForm =
        typeof Elixir_GetProductForm === "function" ? Elixir_GetProductForm() : null;
      if (!productForm) return;

      productForm.querySelectorAll(".premium-kit--products").forEach((el) => el.remove());
      window.__freeGiftsPendingAdd = null;

      // Preview mode: color/greyscale only — never add gift lines to cart yet
      if (!window.__freeGiftsCartEnabled) return;

      if (!allGiftIds.length) return;
      if (typeof Elixir_GetProductFormVariantId !== "function") return;
      const mainVariantId = Elixir_GetProductFormVariantId();
      if (!mainVariantId) return;

      const container = document.createElement("div");
      container.className = "premium-kit--products";

      const existingItemIds = productForm.querySelectorAll(
        'input[name^="items["][name$="[id]"]'
      );
      let index = 0;
      existingItemIds.forEach((input) => {
        const match = input.name.match(/^items\[(\d+)\]\[id\]$/);
        if (match) {
          const n = parseInt(match[1], 10);
          if (n >= index) index = n + 1;
        }
      });

      const mainIdInput = productForm.querySelector('input[name="id"]');
      const hasKaching = !!getKachingWidget();

      // With Kaching, keep the main product as-is (Kaching owns qty/lines).
      // Only append free gifts as extra items[] entries when the form already
      // uses items[], otherwise add gifts after ATC via cart/add.js.
      if (!hasKaching && mainIdInput && existingItemIds.length === 0) {
        const sellingPlan =
          typeof Elixir_GetProductFormSellingPlan === "function"
            ? Elixir_GetProductFormSellingPlan()
            : null;
        const qtyInput =
          productForm.querySelector('input[name="quantity"]') ||
          document.querySelector('input[name="quantity"][form="' + productForm.id + '"]');
        const quantity = qtyInput && qtyInput.value ? qtyInput.value : "1";

        container.appendChild(
          buildHiddenInput("items[0][id]", mainVariantId, "product-variant-id")
        );
        container.appendChild(buildHiddenInput("items[0][quantity]", quantity));
        if (sellingPlan) {
          container.appendChild(buildHiddenInput("items[0][selling_plan]", sellingPlan));
        }
        mainIdInput.remove();
        index = 1;
      } else if (existingItemIds.length > 0 && index === 0) {
        index = existingItemIds.length;
      }

      // If Kaching + single-id form, stash gifts for a follow-up cart/add
      if (hasKaching && mainIdInput && existingItemIds.length === 0) {
        window.__freeGiftsPendingAdd = {
          ids: allGiftIds.slice(),
          relyOnProductId: relyOnProductId || "",
        };
        return;
      }

      window.__freeGiftsPendingAdd = null;

      allGiftIds.forEach((id) => {
        if (id === String(mainVariantId)) return;
        const already = Array.from(
          productForm.querySelectorAll('input[name^="items["][name$="[id]"]')
        ).some((input) => input.value === String(id));
        if (already) return;

        container.appendChild(
          buildHiddenInput(
            `items[${index}][id]`,
            id,
            "product-variant-id premium-kit-free-gift-id"
          )
        );
        container.appendChild(buildHiddenInput(`items[${index}][quantity]`, "1"));
        container.appendChild(
          buildHiddenInput(`items[${index}][properties][_is_free_gift]`, "true")
        );
        if (relyOnProductId) {
          container.appendChild(
            buildHiddenInput(
              `items[${index}][properties][_linked_to_product]`,
              relyOnProductId
            )
          );
        }
        index++;
      });

      if (container.childNodes.length) {
        productForm.appendChild(container);
      }
    } catch (_err) {
      console.log("Error on premium kit script", _err);
    }
  }

  function addPendingGiftsToCart() {
    if (!window.__freeGiftsCartEnabled) {
      window.__freeGiftsPendingAdd = null;
      return Promise.resolve();
    }

    const pending = window.__freeGiftsPendingAdd;
    if (!pending || !pending.ids || !pending.ids.length) return Promise.resolve();

    const items = pending.ids.map((id) => {
      const line = {
        id: Number(id),
        quantity: 1,
        properties: {
          _is_free_gift: "true",
        },
      };
      if (pending.relyOnProductId) {
        line.properties._linked_to_product = String(pending.relyOnProductId);
      }
      return line;
    });

    window.__freeGiftsPendingAdd = null;

    const addUrl =
      (window.routes && window.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + "cart/add.js"
        : "/cart/add.js");

    return fetch(addUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    })
      .then((res) => res.json())
      .catch((err) => console.log("Free gifts add error", err));
  }

  function scheduleSync() {
    setTimeout(syncPremiumKitIntoForm, 0);
    setTimeout(syncPremiumKitIntoForm, 100);
  }

  function applyTierFromDealBarId(widget, dealBarId) {
    if (!dealBarId) return false;
    const idx = resolveDealBarIndex(widget, dealBarId);
    if (!idx) return false;
    window.__freeGiftsKachingTierIndex = idx;
    return true;
  }

  function readSelectedDealBarId(widget) {
    if (!widget) return null;

    try {
      if (typeof widget.selectedDealBarId === "string" && widget.selectedDealBarId) {
        return widget.selectedDealBarId;
      }
      if (widget.selectedDealBarId && widget.selectedDealBarId.id) {
        return widget.selectedDealBarId.id;
      }
    } catch (_err) {}

    const roots = [widget, widget.shadowRoot].filter(Boolean);
    for (const root of roots) {
      const selected =
        root.querySelector("[aria-selected='true'][data-deal-bar-id], [aria-selected='true'][data-deal-id], .selected[data-deal-bar-id], .is-selected[data-deal-bar-id], [data-selected='true'][data-deal-bar-id]") ||
        root.querySelector("[data-deal-bar-id].selected, [data-deal-id].selected, [data-deal-bar-id][aria-checked='true']");
      if (selected) {
        return (
          selected.getAttribute("data-deal-bar-id") ||
          selected.getAttribute("data-deal-id") ||
          selected.getAttribute("data-dealbar-id") ||
          selected.getAttribute("data-id")
        );
      }
    }
    return null;
  }

  function bindKachingWidget(widget) {
    if (!widget || widget.__freeGiftsBound) return;
    widget.__freeGiftsBound = true;

    widget.addEventListener("deal-bar-selected", (event) => {
      const dealBarId = event.detail && event.detail.dealBarId;
      if (dealBarId) {
        applyTierFromDealBarId(widget, dealBarId);
      } else {
        window.__freeGiftsKachingTierIndex = null;
      }
      const qty = getQuantityFromKachingWidget(widget);
      if (qty) window.__freeGiftsKachingQty = qty;
      scheduleSync();
    });

    widget.addEventListener("variants-changed", (event) => {
      const list = event.detail && event.detail.variantIdQuantities;
      if (Array.isArray(list)) {
        window.__freeGiftsKachingQty = list.reduce(
          (sum, row) => sum + (Number(row.quantity) || 0),
          0
        );
        // Prefer explicit deal-bar mapping when known; else fall back to qty as tier
        const selectedId = readSelectedDealBarId(widget);
        if (!applyTierFromDealBarId(widget, selectedId) && window.__freeGiftsKachingQty > 0) {
          window.__freeGiftsKachingTierIndex = Math.min(window.__freeGiftsKachingQty, 4);
        }
      }
      scheduleSync();
    });

    widget.addEventListener("items-changed", () => {
      const qty = getQuantityFromKachingWidget(widget);
      if (qty) window.__freeGiftsKachingQty = qty;
      const selectedId = readSelectedDealBarId(widget);
      if (!applyTierFromDealBarId(widget, selectedId) && qty) {
        window.__freeGiftsKachingTierIndex = Math.min(qty, 4);
      }
      scheduleSync();
    });

    widget.addEventListener("variant-selected", () => scheduleSync());

    // Initial sync once widget is ready
    const selectedId = readSelectedDealBarId(widget);
    const qty = getQuantityFromKachingWidget(widget);
    if (qty) window.__freeGiftsKachingQty = qty;
    if (!applyTierFromDealBarId(widget, selectedId) && qty) {
      window.__freeGiftsKachingTierIndex = Math.min(qty, 4);
    }
    scheduleSync();
  }

  function watchForKaching() {
    const existing = getKachingWidget();
    if (existing) bindKachingWidget(existing);

    document.addEventListener("kaching-bundles-block-loaded", (event) => {
      const widget = (event.detail && event.detail.component) || getKachingWidget();
      bindKachingWidget(widget);
    });

    // Widget may mount after our script
    const observer = new MutationObserver(() => {
      const widget = getKachingWidget();
      if (widget) bindKachingWidget(widget);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 15000);
  }

  document.addEventListener("DOMContentLoaded", () => {
    watchForKaching();
    scheduleSync();
  });

  document.addEventListener("shopify:section:load", () => {
    watchForKaching();
    scheduleSync();
  });

  document.addEventListener("quantity_break:changed", scheduleSync);

  document.addEventListener("bundle-variant-picker:changed", function (event) {
    const index = event.detail && event.detail.index;
    if (index) window.__freeGiftsBundleVariantIndex = index;
    scheduleSync();
  });

  document.addEventListener("simple-variant-picker:variantChange", scheduleSync);
  document.addEventListener("simple-variant-picker:optionChange", scheduleSync);

  document.addEventListener(
    "submit",
    function (event) {
      const form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="cart/add"].product-buy-form-pdp')) {
        return;
      }
      syncPremiumKitIntoForm();
      // After Kaching/theme ATC, add pending gifts
      setTimeout(() => {
        addPendingGiftsToCart().then(() => {
          if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
            try {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "free-gifts" });
            } catch (_e) {}
          }
        });
      }, 600);
    },
    true
  );

  // Theme ATC button clicks (Kaching may intercept / sync qty then submit)
  document.addEventListener(
    "click",
    function (event) {
      if (!event.target || !event.target.closest) return;
      const btn = event.target.closest(
        ".product-form__submit, .shop-add-to-cart-button, button[name='add'], [id^='ProductSubmitButton-']"
      );
      if (!btn) return;
      syncPremiumKitIntoForm();
      setTimeout(() => addPendingGiftsToCart(), 700);
    },
    true
  );
}
